module.exports = __webpack_public_path__ + "static/media/icons8-clock.8d45711c.svg";